<template>
  <img src="@/assets/page-under-construction.png" style="width: 100%" />
</template>

<script>
export default {};
</script>

<style></style>
